import AccountOwnership from 'components/RichProfile/MyAccount/AccountInfo/AccountOwnership/AccountOwnership';
import { withAccountOwnershipProps } from 'viewModel/richProfile/myAccount/accountInfo/accountOwnership/withAccountOwnershipProps';

export default withAccountOwnershipProps(AccountOwnership);
